<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Related Safety Observations</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onManage()"
          *ngIf="canEdit"
          matTooltip="Click this button to link or unlink safety observations.">
          <mat-icon>fact_check</mat-icon>
          Manage Safety Observations
        </button>

        <!-- Selection on this tab only drives Unlink Selected, so the menu and its trigger are
             wrapped together in the edit guard. A mat-menu left outside the guard would still be
             rendered into the CDK overlay. -->
        <ng-container *ngIf="canEdit">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onUnlinkSelected()" [disabled]="!dataSource.selection.hasValue()" *ngIf="canEdit">
              <mat-icon>link_off</mat-icon> Unlink Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Safety Observations." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <button mat-raised-button type="button" class="mr-2 my-1" (click)="onFilter()" matTooltip="Click this button to display filter options.">
          <mat-icon>filter_list</mat-icon> Filter
        </button>

        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search the Safety Observations by description, category, type or status."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let so">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(so.id) : null"
            [checked]="dataSource.selection.isSelected(so.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the safety observation.">
          ID #
        </th>
        <td mat-cell *matCellDef="let so">
          {{ so.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_description">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="280">
          Description
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_description }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_category">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Category
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_category }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_type">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Type
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_priority">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="no-padding" matTooltip="Toggle sorting by priority.">
          Priority
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_priority }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_status">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="no-padding" matTooltip="Toggle sorting by status.">
          Status
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="so_rating">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="no-padding" matTooltip="Toggle sorting by rating.">
          Rating
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.so_rating }}
        </td>
      </ng-container>

      <ng-container matColumnDef="site">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          {{ so.site?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="reported_by_user">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Reported By
        </th>
        <td mat-cell *matCellDef="let so" class="no-padding text-wrap">
          <a *ngIf="so.reported_by_user" (click)="onUserPublicView(so.reported_by_user.hash)" matTooltip="View User Public Profile">
            {{ so.reported_by_user.contact_person }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the date the safety observation was reported.">
          Created At
        </th>
        <td mat-cell *matCellDef="let so">
          {{ (so.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="180"></th>
        <td mat-cell *matCellDef="let so">
          <button type="button" mat-button (click)="onView(so.id)" *ngIf="canViewSafetyObservations">
            View
          </button>
          <button type="button" mat-button (click)="onUnlink(so.id)" *ngIf="canEdit">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
